import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "courier";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = (builder) => {
  createExtraReducers(builder);
};
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const courierActions = { ...slice.actions, ...extraActions };
export const courierReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    courierType: {},
    courierTypeList: [],
    error: null,
    isLoading: false,
    courierResponse: [],
    deleteCourierResponse: [],
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Courier`;
  return {
    getCourierTypeAll: getCourierTypeAll(),
    getCourierById: getCourierById(),
    saveCourier: saveCourier(),
    deleteCourierType: deleteCourierType(),
  };

  function getCourierTypeAll() {
    return createAsyncThunk(
      `${name}/getCourierTypeAll`,
      async () => await fetchWrapper.get(`${baseUrl}/GetCourierTypeDetails`)
    );
  }
  function getCourierById() {
    return createAsyncThunk(
      `${name}/getCourierById`,
      async (detail) =>
        await fetchWrapper.get(
          `${baseUrl}/GetCourierTypeDetails?CourierTypeID=` +
            detail.CourierTypeID
        )
    );
  }

  function saveCourier() {
    return createAsyncThunk(
      `${name}/saveCourier`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${baseUrl}/InsertUpdateCourierType`,
          addFormData
        )
    );
  }

  function deleteCourierType() {
    return createAsyncThunk(
      `${name}/deleteCourierType`,
      async (detail) =>
        await fetchWrapper.post(
          `${baseUrl}/DeleteCourierType?CourierTypeID=${detail.CourierTypeID}&DeletedBy=${detail.DeletedBy}`
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.getCourierTypeAll.pending, (state) => {
      state.isLoading = false;
      state.error = "";
    })
    .addCase(extraActions.getCourierTypeAll.fulfilled, (state, action) => {
      state.isLoading = true;
      state.courierTypeList = action.payload || [];
      state.courierResponse = [];
      state.deleteCourierResponse = [];
    })
    .addCase(extraActions.getCourierTypeAll.rejected, (state, action) => {
      state.isLoading = true;
      state.error = { error: action.error };
    })
    .addCase(extraActions.getCourierById.pending, (state) => {
      state.courierType = { loading: true };
    })
    .addCase(extraActions.getCourierById.fulfilled, (state, action) => {
      state.courierType = action.payload ? action.payload[0] : null;
      state.courierResponse = [];
      state.deleteCourierResponse = [];
    })
    .addCase(extraActions.getCourierById.rejected, (state, action) => {
      state.courierType = { error: action.error };
    })
    .addCase(extraActions.saveCourier.pending, (state) => {
      state.courierResponse = { loading: true };
    })
    .addCase(extraActions.saveCourier.fulfilled, (state, action) => {
      state.courierResponse = action.payload;
      state.deleteCourierResponse = [];
    })
    .addCase(extraActions.saveCourier.rejected, (state, action) => {
      state.courierResponse = { error: action.error };
    })
    .addCase(extraActions.deleteCourierType.pending, (state) => {
      state.deleteCourierResponse = { loading: true };
    })
    .addCase(extraActions.deleteCourierType.fulfilled, (state, action) => {
      state.deleteCourierResponse = action.payload;
      state.courierResponse = [];
    })
    .addCase(extraActions.deleteCourierType.rejected, (state, action) => {
      state.deleteCourierResponse = { error: action.error };
    });
}
